export default __webpack_public_path__ + "static/media/Rectangle_81.31a58612.png";